import script from "./CourseModalTextSettingsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseModalTextSettingsMenu.vue?vue&type=script&setup=true&lang=js"

import "./CourseModalTextSettingsMenu.vue?vue&type=style&index=0&id=3bcd02e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcd02e4"]])

export default __exports__